// Injects Google Analytics (GA4), Google Tag Manager and Google Ads (gtag)
// based on IDs configured by the admin in Settings. All IDs are client-side/public.

let injected = false;

export function injectTracking(settings) {
  if (injected || typeof window === "undefined" || !settings) return;
  const { ga_measurement_id, gtm_id, google_ads_id } = settings;
  if (!ga_measurement_id && !gtm_id && !google_ads_id) return;
  injected = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  // gtag.js (shared by GA4 + Google Ads)
  const gtagId = ga_measurement_id || google_ads_id;
  if (gtagId) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    if (ga_measurement_id) window.gtag("config", ga_measurement_id);
    if (google_ads_id) window.gtag("config", google_ads_id);
  }

  // Google Tag Manager
  if (gtm_id) {
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${gtm_id}`;
    document.head.appendChild(s);
  }
}

// Fire a lead/conversion signal on the thank-you page.
export function fireConversion(settings) {
  if (typeof window === "undefined" || !settings) return;
  injectTracking(settings); // ensure gtag/dataLayer exist even on direct landing
  const { google_ads_id, ads_conversion_label, ga_measurement_id } = settings;

  if (window.gtag && google_ads_id && ads_conversion_label) {
    window.gtag("event", "conversion", {
      send_to: `${google_ads_id}/${ads_conversion_label}`,
    });
  }
  if (window.gtag && ga_measurement_id) {
    window.gtag("event", "generate_lead", {
      event_category: "enquiry",
      event_label: "kiki_enquiry",
    });
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: "enquiry_submitted" });
  }
}
